import React, { useEffect, useState } from 'react';

const SimpleExplicationPage = () => {
    const [pageData, setPageData] = useState(null);

    useEffect(() => {
        fetch('data/explanation_test.json')
            .then(response => response.json())
            .then(data => setPageData(data))
            .catch(error => console.error('Erreur lors du chargement des données', error));
    }, []);

    if (!pageData) return <div>Chargement...</div>;

    return (
        <div className="explanation-page-container" >
            <div className='explanation-page-background-color'></div>

            <div className='explanation-page-background-hero' style={{ backgroundImage: `url(/img/bgrille-m.svg)` }}>
                <div className='explanation-page-background-image' style={{ backgroundImage: `url(${pageData.backgroundImage})` }}></div>
            </div>
            <div className="explanation-page-top-left-indicator">
                <div className="explanation-page-indicator-left">
                    <div className='explanation-page-indicator-bloc'>
                        <div className='explanation-page-indicator-icon'>
                            <img src='/icon/calendar.png' className='explanation-page-indicator-icon-image'></img>
                        </div>
                        <div className='explanation-page-indicator-value date-indicator-value'>
                            12 mai 2050
                        </div>
                    </div>

                    <div className='explanation-page-indicator-bloc'>
                        <div className='explanation-page-indicator-icon'>
                            <img src='/icon/water.png' className='explanation-page-indicator-icon-image'></img>
                        </div>
                        <div className='explanation-page-indicator-value'>
                            {pageData.indicators.waterFootprint.value} {pageData.indicators.waterFootprint.unit}
                        </div>
                    </div>

                    <div className='explanation-page-indicator-bloc'>
                        <div className='explanation-page-indicator-icon'>
                            <img src='/icon/money.png' className='explanation-page-indicator-icon-image'></img>
                        </div>
                        <div className='explanation-page-indicator-value'>
                        {pageData.indicators.budget.value} {pageData.indicators.budget.unit}
                        </div>
                    </div>
                </div>
            </div>
            <div className="explanation-page-top-right">
                <div className="explanation-page-indicator-right">
                    <img src={pageData.logo} alt="Logo" className="explanation-page-logo" />
                </div>    
            </div>
            <div className="explanation-page-text">
                <p>{pageData.text}</p>
            </div>
            <div>
                <button className='back-button'>Suivant</button>
            </div>
        </div>
    );
};

export default SimpleExplicationPage;
